import React, { Fragment } from 'react';
import { Input, Popup } from 'semantic-ui-react';
import BigNumber from 'bignumber.js';

import * as ProdRecordHelpers from 'Pages/manageproduction/helpers/productionRecord';
import { ProductionRecordDetailFieldEnum as ProdRecordDetailFields } from 'Common/FieldEnum';
import { InputMode } from 'Common/FormEnum';

import { GridInputCell } from './GridInputCell';
import { GridCheckboxCell } from './GridCheckboxCell';

function PlannedSectionRow(props) {
  const {
    onGridInputChange,
    adjustPercentage,
    [ProdRecordDetailFields.ArrayIndex]: index,
    collapsed,
    onInputChange,
    feedingFigure,
    ...detailProps
  } = props;
  let ff = feedingFigure || 1;

  const ingAmount = detailProps[ProdRecordDetailFields.IngredientAmount];
  const isIngredient = ProdRecordHelpers.isDetailIngredient(detailProps);
  const onPercentageBlur = (e) => {
    let percentage = new BigNumber(e.target.value).dividedBy(100);

    // Compute the new planned reimbursable amount based on the percentage
    const plannedReimb = percentage.multipliedBy(ff).decimalPlaces(0);

    // Update the percentage using the new planned amount because the rounding may cause it to be inaccurate
    percentage = plannedReimb.dividedBy(ff).multipliedBy(100).toFixed(2);

    onInputChange({
      target: {
        name: ProdRecordDetailFields.PlannedPercentage,
        value: percentage,
        index,
      },
    });
  };

  return (
    <Fragment>
      <GridInputCell
        {...detailProps}
        inputProps={{
          name: ProdRecordDetailFields.ReimbursableMeals,
          onChange: onInputChange,
          value: detailProps[ProdRecordDetailFields.ReimbursableMeals],
          'data-index': index,
        }}
        mode={InputMode.Integer}
      />
      {!collapsed && (
        <Fragment>
          <GridInputCell
            {...detailProps}
            inputProps={{
              inputLabelProps: {
                label: '%',
                labelPosition: 'right',
              },
              onChange: onInputChange,
              onBlur: onPercentageBlur,
              name: ProdRecordDetailFields.PlannedPercentage,
              value: detailProps[ProdRecordDetailFields.PlannedPercentage],
              'data-index': index,
              disabled: feedingFigure
                ? !parseInt(feedingFigure, 10) ||
                  parseInt(feedingFigure, 10) === 0
                : true,
            }}
            mode={InputMode.Decimal}
          />
          <GridInputCell
            {...detailProps}
            inputProps={{
              name: ProdRecordDetailFields.PlannedPreK,
              onChange: onInputChange,
              value: detailProps[ProdRecordDetailFields.PlannedPreK],
              'data-index': index,
            }}
            mode={InputMode.Integer}
          />
          <GridInputCell
            {...detailProps}
            inputProps={{
              name: ProdRecordDetailFields.PlannedAlacarte,
              onChange: onInputChange,
              value: detailProps[ProdRecordDetailFields.PlannedAlacarte],
              'data-index': index,
            }}
            mode={InputMode.Integer}
          />
          <GridInputCell
            {...detailProps}
            inputProps={{
              name: ProdRecordDetailFields.PlannedAdult,
              onChange: onInputChange,
              value: detailProps[ProdRecordDetailFields.PlannedAdult],
              'data-index': index,
            }}
            mode={InputMode.Integer}
          />
          {isIngredient ? (
            <Input className="menu-input" disabled value="" />
          ) : (
            <Input
              className="menu-input"
              value={ProdRecordHelpers.computePlannedTotal(detailProps)}
              fluid
              disabled
            />
          )}
          <div className="grid-item">
            <Popup
              content={ingAmount}
              trigger={<div className="text-ellipsis-cell">{ingAmount}</div>}
            />
          </div>
          <GridCheckboxCell
            {...detailProps}
            inputProps={{
              name: ProdRecordDetailFields.Kitchen,
              onChange: onInputChange,
              checked: detailProps[ProdRecordDetailFields.Kitchen],
              'data-index': index,
            }}
          />
        </Fragment>
      )}
    </Fragment>
  );
}

const MemoizedPlannedSectionRow = React.memo(PlannedSectionRow);

export { MemoizedPlannedSectionRow as PlannedSectionRow };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/PlannedSectionRow.js